import CloseButton from "../CloseButton";

import "./style.css";

function CustomSliderModal({ show, setShow, children, title }) {
    return (
        <>
            <div id='custom-slider-modal' style={show ? { top: "0%" } : {}}>
                <CloseButton onClick={() => {
                    setShow(false);
                }} />
                <h4>{title}</h4>
                {
                    children
                }
            </div>

        </>
    );
}

export default CustomSliderModal;